import React, { FC, useState } from "react";
import { Select } from "antd";
import { Props, defaultData } from "./types";
import TimeZoneInput from "../../../components/timeZone/TimeZoneInput";

const TimeSettings: FC<Props> = ({ data = defaultData, setData }) => {
  let _v = "";
  if (data.showDate) _v = _v.concat("Date");
  if (data.showDate && data.showTime) _v = _v.concat(" ");
  if (data.showTime) {
    _v = _v.concat("HH");
    _v = data.hour12 ? _v.concat("12") : _v.concat("24");
    if (data.showTime) _v = _v.concat(":MI");
    if (data.showSeconds) _v = _v.concat(":SS");
  }
  const [v, setV] = useState(_v);
  const handleChange = (value: string) => {
    const _showDate = value.startsWith("Date");
    const _showTime = value.indexOf("HH") !== -1;
    const _hour12 = value.indexOf("HH12") !== -1;
    const _showSeconds = value.indexOf("SS") !== -1;
    const _showMinutes = value.indexOf("MI") !== -1;
    const _showDayPeriod = _hour12;
    setData({
      ...data,
      showDate: _showDate,
      showTime: _showTime,
      hour12: _hour12,
      showSeconds: _showSeconds,
      showMinutes: _showMinutes,
      showDayPeriod: _showDayPeriod,
    });
    setV(value);
  };

  return (
  <div className="TimeSettings">
    <label>
      Time Zone
      <TimeZoneInput
        timeZone={data.timeZone}
        onChange={(timeZone) => setData({ ...data, timeZone })}
      />
    </label>
    <label>
      Show Datetime format
      <Select
        style={{ display: 'block' }}
        value={v}
        onChange={handleChange}
        options={[
          { value: 'Date', label: 'Date' },
          { value: 'Date HH24', label: 'Date HH24' },
          { value: 'Date HH24:MI', label: 'Date HH24:MI' },
          { value: 'Date HH24:MI:SS', label: 'Date HH24:MI:SS' },
          { value: 'Date HH12', label: 'Date HH12' },
          { value: 'Date HH12:MI', label: 'Date HH12:MI' },
          { value: 'Date HH12:MI:SS', label: 'Date HH12:MI:SS' },
          { value: 'HH24', label: 'HH24' },
          { value: 'HH24:MI', label: 'HH24:MI' },
          { value: 'HH24:MI:SS', label: 'HH24:MI:SS' },
          { value: 'HH12', label: 'HH12' },
          { value: 'HH12:MI', label: 'HH12:MI' },
          { value: 'HH12:MI:SS', label: 'HH12:MI:SS' },
        ]}
      />
    </label>
  </div>
)};

export default TimeSettings;
